import React, { Component } from 'react';
import classnames from 'classnames';
import { getText } from 'src/utils/i18n';
import '../detail-market-action/index.scss';
import './index.scss';

function RangePrice(props) {
  const {
    hasFOB,
    moq,
    unit,
    unitEven,
    productRangePrices,
    i18n,
    hasMOQ,
    isBatch,
    batchNum,
    showPromotionPrice,
    // TODO: 活动相关需添加，如barginbuys
    showActivity,
  } = props;
  const cls = classnames(
    'ma-reference-price',
    {
      'ma-reference-price-promotion': showPromotionPrice,
    },
    {
      'long-split': showActivity,
    },
  );
  if (showPromotionPrice) {
    return (
      <div className={cls}>
        <div className="ma-reference-price-promotion-price ">
          <div className="ma-props">
            <span className="ma-reference-price-highlight">
              {productRangePrices.pricePromotionRangeText}
            </span>
            <span> {unit ? `/ ${unit}` : ''}</span>
            {hasFOB && <span className="ma-split">|</span>}
            {hasMOQ && (
              <span className="ma-min-order">
                {moq} {moq > 1 ? unitEven : unit}
              </span>
            )}
            {hasMOQ && isBatch && (
              <strong className="brief-mark">
                {' '}
                ({moq / batchNum}{' '}
                {getText(i18n, 'marketAction.batch.lot', 'lot')}){' '}
              </strong>
            )}
            {hasMOQ && (
              <span>
                {getText(i18n, 'mainACtion_reference_mo', '(Min. Order)')}
              </span>
            )}
          </div>
          {!!productRangePrices.priceRangeText && (
            <div className="ma-props">
              <span className="ma-promotion-props">
                {productRangePrices.priceRangeText}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className={cls}>
      {hasFOB &&
        productRangePrices &&
        productRangePrices.priceRangeText && [
          <span className="ma-ref-price" key="ma-ref-price">
            <span>{productRangePrices.priceRangeText}</span>
          </span>,
          <span key="unit">{unit ? `/ ${unit}` : ''}</span>,
        ]}
      {hasFOB && <span className="ma-split">|</span>}
      {hasMOQ && (
        <span className="ma-min-order">
          {/* {moq} {moq > 1 ? unitEven : unit} */}
          {moq} {unit}/{unitEven}
        </span>
      )}
      {hasMOQ && isBatch && (
        <strong className="brief-mark">
          {' '}
          ({moq / batchNum} {getText(i18n, 'marketAction.batch.lot', 'lot')}){' '}
        </strong>
      )}
      {hasMOQ && (
        <span>{getText(i18n, 'mainACtion_reference_mo', '(Min. Order)')}</span>
      )}
    </div>
  );
}

// bb营销态有batch逻辑
function LadderPrice(props) {
  const {
    productLadderPrices,
    unitEven,
    showPromotionPrice,
    currentLadderIndex = 0,
    productIsMarketGoods,
  } = props;
  return (
    <ul
      id="ladderPrice"
      className={`ma-ladder-price ma-ladder-price-count-${productLadderPrices.length} util-clearfix`}
    >
      {productLadderPrices.map((ladderPrice, index) => {
        const cls = classnames('ma-ladder-price-item', {
          'current-ladder-price':
            index === currentLadderIndex && productIsMarketGoods,
        });
        const cls2 = classnames('ma-spec-price', {
          'ma-price-promotion': index === currentLadderIndex,
        });
        return (
          <li
            data-role="ladder-price-item"
            className={cls}
            style={{ backgroundColor: '#FFF' }}
            key={index}
          >
            {ladderPrice.max != -1
              ? [
                  <span
                    className="ma-quantity-range"
                    title={`${ladderPrice.min} - ${ladderPrice.max} ${unitEven}`}
                    key={`${ladderPrice.min} - ${ladderPrice.max}`}
                  >
                    {ladderPrice.min} - {ladderPrice.max} {unitEven}
                  </span>,
                  <div
                    className={cls2}
                    title={
                      !!showPromotionPrice
                        ? ladderPrice.formatPromotionPrice
                        : ladderPrice.formatPrice
                    }
                    key={cls2}
                  >
                    <span className="pre-inquiry-price">
                      {!!showPromotionPrice
                        ? ladderPrice.formatPromotionPrice
                        : ladderPrice.formatPrice}
                    </span>
                  </div>,
                  <div
                    className="ma-spec-price ma-price-original"
                    key="ma-spec-price ma-price-original"
                  >
                    {!!showPromotionPrice && (
                      <span
                        className="priceVal"
                        title={ladderPrice.formatPrice}
                      >
                        {ladderPrice.formatPrice}
                      </span>
                    )}
                  </div>,
                ]
              : [
                  <span
                    className="ma-quantity-range"
                    title={`>=${ladderPrice.min} ${unitEven}`}
                    key={`${ladderPrice.min}`}
                  >
                    {' '}
                    {'>='}
                    {ladderPrice.min} {unitEven}
                  </span>,
                  <div
                    className="ma-spec-price"
                    title={
                      !!showPromotionPrice
                        ? ladderPrice.formatPromotionPrice
                        : ladderPrice.formatPrice
                    }
                    key="ma-spec-price"
                  >
                    <span className="pre-inquiry-price">
                      {!!showPromotionPrice
                        ? ladderPrice.formatPromotionPrice
                        : ladderPrice.formatPrice}
                    </span>
                  </div>,
                  <div
                    className="ma-spec-price ma-price-original"
                    key="ma-spec-price ma-price-original"
                  >
                    {!!showPromotionPrice && (
                      <span
                        className="priceVal"
                        title={ladderPrice.formatPrice}
                      >
                        {ladderPrice.formatPrice}
                      </span>
                    )}
                  </div>,
                ]}
          </li>
        );
      })}
    </ul>
  );
}

function FixedPrice(props) {
  const {
    hasFOB,
    moq,
    unit,
    unitEven,
    formatFixedPrice,
    formatPromotionFixedPrice,
    i18n,
    hasMOQ,
    isBatch,
    batchNum,
    showPromotionPrice,
    // TODO: 活动相关需添加，如barginbuys
    showActivity,
  } = props;
  const cls = classnames(
    'ma-reference-price',
    {
      'ma-reference-price-promotion': showPromotionPrice,
    },
    {
      'long-split': showActivity,
    },
  );
  if (showPromotionPrice) {
    return (
      <div className={cls}>
        <div className="ma-reference-price-promotion-price ">
          <div className="ma-props">
            <span className="ma-reference-price-highlight">
              {formatPromotionFixedPrice}
            </span>
            <span> {unit ? `/ ${unit} ` : ' '}</span>
            {hasFOB && <span className="ma-split">|</span>}
            {hasMOQ && (
              <span className="ma-min-order">
                {moq} {moq > 1 ? unitEven : unit}
              </span>
            )}
            {hasMOQ && isBatch && (
              <strong className="brief-mark">
                {' '}
                ({moq / batchNum}{' '}
                {getText(i18n, 'marketAction.batch.lot', 'lot')}){' '}
              </strong>
            )}
            {hasMOQ && (
              <span>
                {getText(i18n, 'mainACtion_reference_mo', '(Min. Order)')}
              </span>
            )}
          </div>
          {!!formatFixedPrice && (
            <div className="ma-props">
              <span className="ma-promotion-props">{formatFixedPrice}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className={cls}>
      {formatFixedPrice && [
        <span className="ma-ref-price" key="ma-ref-price">
          <span>{formatFixedPrice}</span>
        </span>,
        <span key="unit">{unit ? `/ ${unit} ` : ' '}</span>,
      ]}
      {hasFOB && <span className="ma-split">|</span>}
      {hasMOQ && (
        <span className="ma-min-order">
          {moq} {moq > 1 ? unitEven : unit}
        </span>
      )}
      {hasMOQ && isBatch && (
        <strong className="brief-mark">
          {' '}
          ({moq / batchNum} {getText(i18n, 'marketAction.batch.lot', 'lot')}){' '}
        </strong>
      )}
      {hasMOQ && (
        <span>{getText(i18n, 'mainACtion_reference_mo', '(Min. Order)')}</span>
      )}
    </div>
  );
}
export default class Price extends Component {
  render() {
    const { props } = this;
    const {
      // productLadderPrices, 收拢到price字段中
      // productFobPriceUnit: unit,
      // productFobPriceUnitEven: unitEven,
      // quantityUnitOddStr: unit2,
      // quantityUnitComplexStr: unitEven2,
      // // moq字段要收拢
      // productTransactionProperties,
      // reviewType,
      // // 价格范围要收拢
      // productPriceRangeLow,
      // productPriceRangeHigh,
      // promotionView,
      // price,
      // minOrder,
      // isBatch,
      // batchNum,
      price = {},
      moq,
      showPromotionPrice,
      i18n,
      productIsMarketGoods,
    } = props;
    const {
      productLadderPrices,
      productRangePrices,
      unit,
      unitEven,
      saleType,
      batchNum,
      formatFixedPrice,
      formatPromotionFixedPrice,
    } = price;
    const hasLadderPrice = !!(
      productLadderPrices && productLadderPrices.length
    );
    const isBatch = saleType === 'batch';
    // 询盘品
    const hasFOB =
      productRangePrices &&
      productRangePrices.priceRangeLow &&
      productRangePrices.priceRangeHigh &&
      productRangePrices.priceRangeText;
    const hasMOQ = !!moq;
    return (
      <div className="widget-main-action">
        <div className="ma-price-wrap">
          {/* 阶梯价 */}
          {hasLadderPrice && (
            <LadderPrice
              productLadderPrices={productLadderPrices}
              unit={unit}
              unitEven={unitEven}
              i18n={i18n}
              showPromotionPrice={showPromotionPrice}
              productIsMarketGoods={productIsMarketGoods}
            />
          )}
          {/* 范围价 */}
          {productRangePrices && (
            <RangePrice
              productRangePrices={productRangePrices}
              moq={moq}
              hasMOQ={hasMOQ}
              hasFOB={hasFOB}
              i18n={i18n}
              unit={unit}
              unitEven={unitEven}
              batchNum={batchNum}
              isBatch={isBatch}
              showPromotionPrice={showPromotionPrice}
            />
          )}
          {/* 一口价 */}
          {formatFixedPrice && (
            <FixedPrice
              formatFixedPrice={formatFixedPrice}
              formatPromotionFixedPrice={formatPromotionFixedPrice}
              moq={moq}
              hasMOQ={hasMOQ}
              hasFOB={hasFOB}
              i18n={i18n}
              unit={unit}
              unitEven={unitEven}
              batchNum={batchNum}
              isBatch={isBatch}
              showPromotionPrice={showPromotionPrice}
            />
          )}
        </div>
      </div>
    );
  }
}
